// @flow

/* Libs */
import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';

/* Components */
import Header from 'Components/Header';
import Furnitures from './components/Furnitures';
import Products from './components/Products';

const Inventory = () => (
	<div>
		<Header title="Gestion de l'inventaire">
			<div className="App-Navigation">
				<NavLink to="/inventory" exact>Tableau de bord</NavLink>
				<NavLink to="/inventory/furnitures">Matière premières</NavLink>
				<NavLink to="/inventory/products">Produits</NavLink>
				<NavLink to="/inventory/suppliers">Fournisseurs</NavLink>
			</div>
		</Header>

		<div className="App-Content">
			<Switch>
				<Route path="/inventory" exact>
					<p>Hello world</p>
				</Route>
				<Route path="/inventory/furnitures">
					<Furnitures />
				</Route>
				<Route path="/inventory/products">
					<Products />
				</Route>
				<Route path="/inventory/suppliers">
					<p>Liste des fournisseurs</p>
				</Route>
			</Switch>
		</div>
	</div>
);

export default Inventory;
